/**
 * Manages the sticky offset for product details based on header and bottom component heights
 * Updates the --sticky-header-offset CSS variable dynamically
 */

class StickyOffsetManager {
  constructor() {
    this.headerSelector = '#header-component';
    this.productDetailsSelector = '.product-details.sticky-content--desktop';
    this.bottomComponentSelector = 'bottom-component[sticky="true"]';
    this.lastOffset = null;
    this.resizeObservers = [];

    this.init();
  }

  init() {
    // Listen for bottom component size changes
    window.addEventListener('bottom-component-size-changed', (e) => {
      this.updateStickyOffset();
    });

    // Setup ResizeObserver for header
    const header = document.querySelector(this.headerSelector);
    if (header) {
      const headerResizeObserver = new ResizeObserver(() => {
        this.updateStickyOffset();
      });
      headerResizeObserver.observe(header);
      this.resizeObservers.push(headerResizeObserver);
    }

    // Setup ResizeObserver for bottom component
    const bottomComponent = document.querySelector(this.bottomComponentSelector);
    if (bottomComponent) {
      const bottomResizeObserver = new ResizeObserver(() => {
        this.updateStickyOffset();
      });
      bottomResizeObserver.observe(bottomComponent);
      this.resizeObservers.push(bottomResizeObserver);
    }

    // Initial update
    this.updateStickyOffset();
  }

  updateStickyOffset() {
    const productDetails = document.querySelector(this.productDetailsSelector);
    if (!productDetails) return;

    let totalOffset = 0;

    // Add header height if it's sticky
    const header = document.querySelector(this.headerSelector);
    if (header) {
      const headerHeight = header.offsetHeight;
      if (headerHeight > 0) {
        totalOffset += headerHeight;
      }
    }

    // Add bottom component height if it's sticky
    const bottomComponent = document.querySelector(this.bottomComponentSelector);
    if (bottomComponent) {
      const bottomHeight = bottomComponent.offsetHeight;
      if (bottomHeight > 0) {
        totalOffset += bottomHeight;
      }
    }

    // Only update if the offset has changed
    if (totalOffset !== this.lastOffset) {
      this.lastOffset = totalOffset;
      productDetails.style.setProperty('--sticky-header-offset', `${totalOffset}px`);
    }
  }

  cleanup() {
    this.resizeObservers.forEach(observer => observer.disconnect());
    this.resizeObservers = [];
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyOffsetManager();
  });
} else {
  new StickyOffsetManager();
}

